const htmlEncode = (value) => {
    const div = document.createElement("div");
    div.textContent = value;
    return div.innerHTML;
};
export const buildHtmlTileDescription = (items) => `<ul>${items.map((item) => `<li>${htmlEncode(item)}</li>`).join("")}</ul>`;
/**
 * Maps a backend-validated SpecialEventsTile DTO into the EscalationSetting
 * shape consumed by the Escalations grid.
 */
export const specialEventsTileToEscalationSetting = (tile) => ({
    title: tile.title,
    description: buildHtmlTileDescription(tile.description),
    link: tile.linkUrl,
    linkName: tile.linkName,
    name: tile.title,
});
